import apiClient from '@/api/apiClient';
import type { DataUnitProductKey } from '@/constants/dataUnitProducts';
import type { DataUnitPricesResponse } from '@/types/billing';

const dataUnitsApi = {
  getDataUnitPrices(keys: DataUnitProductKey[]): Promise<DataUnitPricesResponse> {
    return apiClient.get('/data-units/prices', { params: { keys } });
  },
};

export default dataUnitsApi;
